import { useQuery } from "@tanstack/react-query";

import {

    getWalletDetails,

} from "../services/wallet.js";

export function useWalletDetails(outletUid) {

    return useQuery({

        queryKey: [

            "walletDetails",

            outletUid,

        ],

        queryFn: () =>
            getWalletDetails(

                outletUid

            ),

        enabled:

            Boolean(outletUid),

    });

}